import _extends from "@babel/runtime-corejs3/helpers/extends";
import React from 'react';
import { validProgress, handleGradient } from './utils';
var Line = function Line(props) {
  var prefixCls = props.prefixCls,
    children = props.children,
    percent = props.percent,
    trailColor = props.trailColor,
    strokeColor = props.strokeColor,
    strokeWidth = props.strokeWidth;
  var backgroundProps = strokeColor && typeof strokeColor !== 'string' ? handleGradient(strokeColor) : {
    background: strokeColor
  };
  var trailStyle = {
    backgroundColor: trailColor || undefined
  };
  var percentStyle = _extends({
    width: "".concat(validProgress(percent), "%"),
    height: strokeWidth && "".concat(strokeWidth, "px")
  }, backgroundProps);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-outer")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-inner"),
    style: trailStyle
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "-bg"),
    style: percentStyle
  }))), children);
};
Line.displayName = 'Line';
export default Line;